// Business-day (Mon-Fri) deadline calculation — mirrors backend compute_deadline_at.
export function computeDeadline(createdAtIso, hours) {
  let current = new Date(createdAtIso);
  let remaining = hours;
  while (remaining > 0) {
    const day = current.getUTCDay(); // 0=Sun..6=Sat
    if (day >= 1 && day <= 5) {
      const midnight = new Date(current);
      midnight.setUTCDate(midnight.getUTCDate() + 1);
      midnight.setUTCHours(0, 0, 0, 0);
      const hrsLeftToday = (midnight - current) / 3600000;
      if (remaining <= hrsLeftToday) {
        current = new Date(current.getTime() + remaining * 3600000);
        remaining = 0;
      } else {
        current = midnight;
        remaining -= hrsLeftToday;
      }
    } else {
      current.setUTCDate(current.getUTCDate() + 1);
      current.setUTCHours(0, 0, 0, 0);
    }
  }
  return current;
}

export function getUrgency(remainingHours) {
  if (remainingHours <= 0) return { color: 'text-red-400', bg: 'bg-red-400/10', label: 'Vencido' };
  if (remainingHours < 12) return { color: 'text-red-400', bg: 'bg-red-400/10', label: null };
  if (remainingHours <= 24) return { color: 'text-amber-400', bg: 'bg-amber-400/10', label: null };
  return { color: 'text-white/50', bg: '', label: null };
}

export function formatRemaining(remainingHours) {
  if (remainingHours <= 0) return 'Vencido';
  const h = Math.floor(remainingHours);
  const d = Math.floor(h / 24);
  const rh = h % 24;
  if (d > 0) return `${d}d ${rh}h`;
  return `${h}h`;
}

export function deadlineInfo(createdAtIso, plazoHoras, stopped) {
  if (!createdAtIso) return null;
  const deadline = computeDeadline(createdAtIso, plazoHoras);
  const remainingHours = (deadline - new Date()) / 3600000;
  const urgency = stopped ? { color: 'text-white/30', bg: '', label: null } : getUrgency(remainingHours);
  return { deadline, remainingHours, urgency, stopped };
}
